import { useRef, useEffect, useMemo } from 'react'
import { InputLabel } from "../partials/input-label";
import { InputValidationError } from "../partials/input-validation-error";
import Cleave from 'cleave.js/react';
import 'cleave.js/dist/addons/cleave-phone.tr.js'

const TextInput = ({
	inputType: inputTypeProp, onChangePlainValue, onChange, initialized,
	className, label, validationError,
	autoComplete, value, mask, innerContent,
	...props
}) => {
	const inputRef = useRef();

	// Set initial plain value.
	const plainValue = useMemo(() => {
		if(inputTypeProp === 'phone') {
			let plainValue = value.replace(/\s/g,'');
			if(!plainValue.startsWith('+')){
				if(plainValue.startsWith('00')){
					plainValue = plainValue.replace('00', '+');
				}
				else if(plainValue.startsWith('0')) {
					plainValue = '+9' + plainValue;
				}
				else {
					plainValue = '+90' + plainValue;
				}
			}
			return plainValue;
		}
		return value;
	}, [value, inputTypeProp])

	useEffect(() => {
		onChangePlainValue(plainValue);
	}, [plainValue])

	const { component: Component, ...computedProps } = useMemo(() => {
		let props = {
			type: 'text',
			component: 'input'
		}
		if(inputTypeProp === 'phone') {
			props.component = Cleave;
			props.options = {
				phone: true,
				phoneRegionCode: 'TR',
				delimiter: ' ',
			}
			props.inputMode = 'tel';
			props.pattern = '[0-9.]+';
		}
		else if(inputTypeProp === 'number') {
			props.component = Cleave;
			props.options = {
				numeral: true,
				numeralThousandsGroupStyle: 'none',
				stripLeadingZeroes: false,
			}
			props.inputMode = 'numeric';
			props.pattern = '[0-9.]';
		}
		else if(inputTypeProp === 'date') {
			props.component = Cleave;
			props.options = {
				date: true,
				delimiter: '/',
				datePattern: ['d', 'm', 'Y'],
			}
			props.inputMode = 'numeric';
			props.pattern = '[0-9.]';
		}
		else if(mask) {
			props.component = Cleave;

			if(mask === 'creditcard') {
				props.pattern = '[0-9]*'
				props.inputMode = 'numeric';

				props.options = {
					creditCard: true,
				}
			}
			else if (mask === 'expiry') {
				props.pattern = '[0-9]*';
				props.inputMode = 'numeric';

				props.options = {
					date: true,
					datePattern: ['m', 'y']
				}
			}
		}
		else if(inputTypeProp === 'password') {
			props.type = 'password';
		}

		return props;
	}, [inputTypeProp, mask])

	const handleChange = e => {
		onChange(e.target.value);
	}

	useEffect(() => {
		if (inputRef.current && typeof inputRef.current === 'function' && inputRef.current.matches(':-internal-autofill-selected')) {
			inputRef.current.click();
		}
	}, [])

	return (
		<div className={className}>
			<InputLabel label={label} name={props.id} />
			<div className="inputwrap-innerwrap">
				{innerContent}
				<Component
					ref={inputRef}
					onChange={handleChange}
					className={'inputwrap-input'}
					autoComplete={autoComplete || 'off'}
					value={value}
					{...computedProps}
					{...props} />
			</div>
			<InputValidationError error={validationError} />
		</div>
	)
}

export default TextInput;